import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  mobileMenuOpen = false;
  year = new Date().getFullYear();
  languages = ['en', 'ro'];
  currentLang = 'en';

  constructor(public translate: TranslateService) {
    const savedLanguage = localStorage.getItem('language') || 'en';
    const languageToUse = /^(en|ro)$/.test(savedLanguage) ? savedLanguage : 'en';
    this.currentLang = languageToUse;
    this.translate.use(languageToUse);
    localStorage.setItem('language', languageToUse);
  }

  onChangeLanguage(language: string): void {
    if (!/^(en|ro)$/.test(language)) {
      return;
    }
    this.currentLang = language;
    localStorage.setItem('language', language);
    this.translate.use(language);
  }

  getLanguageLabel(code: string): string {
    switch (code) {
      case 'ro':
        return 'Română';
      case 'en':
      default:
        return 'English';
    }
  }

  toggleMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMenu(): void {
    this.mobileMenuOpen = false;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
